import { render, staticRenderFns } from "./GameFlagsCombobox.vue?vue&type=template&id=138196f5"
import script from "./GameFlagsCombobox.js?vue&type=script&lang=js&external"
export * from "./GameFlagsCombobox.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports